import {useCanGoBack, useHistory} from '@aboutyou/router';
import {useEffect} from 'react';

export const RedirectBack = (props: {fallbackUrl: string}) => {
  const canGoBack = useCanGoBack();
  const history = useHistory();
  useEffect(() => {
    if (canGoBack) {
      history.goBack();
    } else {
      history.push(props.fallbackUrl);
    }
  });

  return null;
};
